module.exports = __webpack_public_path__ + "img/FR12579.1603c867.png";